<template>
  <div id="licenseproduct-detail">
    <div
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <detail
      v-if="item !== null && !loading"
      :item="item"
    >
      <template slot="content">
        <div xs12>
          <!--가격 & 최소 주문 수량-->
          <div class="detail-row">
            <div v-if="isKorean()">
              <div class="detail-row-title">
                {{ $t("newLP.price") }}
              </div>
              <div class="detail-row-content">
                {{ item.price? parsePrice(item.price) : " - " }}
              </div>
            </div>
            <div class="detail-row-title">
              {{ $t("newCartPage.MOQ") }}
            </div>
            <div class="detail-row-content">
              <span v-if="item.export">{{ item.MOQ || 1 }}</span>
              <span v-else> - </span>
            </div>
          </div>
          <!--카테고리-->
          <div class="detail-row">
            <div class="detail-row-title">
              {{ $t("variables.category") }}
            </div>
            <div class="detail-row-content">
              {{ item.category ? item.category.name : '' }}
            </div>
          </div>
          <!--출시년도-->
          <div class="detail-row">
            <div class="detail-row-title">
              {{ $t("newLP.year") }}
            </div>
            <div class="detail-row-content">
              {{ item.release_year }}
            </div>
          </div>
          <!--라이선시-->
          <div class="detail-row">
            <div class="detail-row-title">
              IP
            </div>
            <div class="detail-row-content">
              {{ item.IP ? item.IP.name : '' }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-row-title">
              {{ $t('newLP.sound') }}
            </div>
            <div class="detail-row-content">
              {{ item.sound_language? item.sound_language.name : "" }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-row-title">
              {{ $t("newLP.maker") }}
            </div>
            <div class="detail-row-content">
              {{ item.licensee ? item.licensee.name : '' }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-row-title">
              {{ $t("newLP.releasedCountry") }}
            </div>
            <div
              class="detail-row-content"
              style="padding-top: 5px;"
            >
              <v-layout
                row
                wrap
              >
                <v-flex
                  v-for="country in item.release_country"
                  :key="country.code"
                  class="card-info-country-tag"
                  style="flex: unset;"
                >
                  {{ country.name }}
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </template>
      <template slot="buttons">
        <v-layout
          row
          wrap
          align-center
          justify-center
        >
          <v-flex
            v-if="item.option.length > 0"
            class="card-info-action"
            xl12
            lg12
            md12
            sm12
            xs12
          >
            <multiselect
              v-model="selectedOption"
              track-by="code"
              label="name"
              :options="item.option ? item.option : []"
              :searchable="false"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              :placeholder="$t('newLP.selectOption')"
              style="width: 100%"
              @input="onSelectedOptionChanged('licensedproducts', item)"
            >
              <template
                slot="singleLabel"
                slot-scope="{ option }"
              >
                {{ option.name }}
              </template>
            </multiselect>
          </v-flex>
          <v-flex
            class="card-info-action"
            xl12
            lg12
            md12
            sm12
            xs12
          >
            <v-btn
              id="add-to-cart-btn"
              :disabled="!item.export"
              :style="{ backgroundColor: addToCartBtnColor }"
              @click="addToCart('licensedproducts', item)"
            >
              <div
                v-if="!isChecked"
                class="btn-text-field"
              >
                {{ $t("newLP.addCart") }}
              </div>
              <div
                v-if="isChecked"
                class="btn-text-field"
              >
                <div> {{ $t("newLP.alreadyAdded") }} </div>
                <i
                  class="icon material-icons"
                  style="padding-bottom: 8px; padding-left: 10px;"
                >
                  done
                </i>
              </div>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </detail>
    <detail
      v-if="item === null && !loading"
      :item="item"
    >
      <template
        slot="not-found"
      >
        <div id="selected-products-empty">
          <img
            :src="require('../../assets/empty_cart.png')"
            style="margin-left: -33px;"
          >
          <p id="selected-products-empty-title">
            404 Not Found
          </p>
        </div>
      </template>
    </detail>
  </div>
</template>

<script>
import Detail from 'components/Detail.vue'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
const DEFAULT_ADD_TO_BTN_COLOR = 'rgb(255 104 175)'

export default {
  components: {
    'detail': Detail,
    Multiselect
  },
  data () {
    return {
      item: {
        name: '',
        licensee: { name: '' },
        release_country: [],
        price: null,
        category: { name: '' },
        export: false,
        release_year: 0,
        option: []
      },
      loading: false,
      selectedOption: null,
      isChecked: false,
      addToCartBtnColor: DEFAULT_ADD_TO_BTN_COLOR
    }
  },
  watch: {
    '$store.getters.selected' () {
      this.updateChecked('licensedproducts', this.item)
    },
    '$route.params.id' () {
      this.initUI()
      window.scrollTo(0, 0)
      this.getProductDetail()
    }
  },
  beforeMount () {
    window.scrollTo(0, 0)
    this.getProductDetail()
  },
  methods: {
    initUI () {
      this.loading = false
      this.selectedOption = null
      this.isChecked = false
    },
    getProductDetail: function () {
      this.loading = true
      const lang = this.$route.path.split('/')[1]
      this.$http.get('/api/products/licensedproducts/' + this.$route.params.id + '/?lang=' + lang)
        .then(response => {
          this.loading = false
          this.item = response.data
          this.updateChecked('licensedproducts', this.item)
        }).catch(err => {
          this.loading = false
          this.item = null
          console.error(err)
        })
    },
    getOrderCode (item) {
      const orderCode = item.option.length === 0 ? item.LP_code : this.selectedOption.code
      return orderCode
    },
    updateChecked (product, item) {
      // 옵션 존재 상품인데 아직 미 선택 상태일 경우 false 리턴
      if (item.option.length > 0 && !this.selectedOption) {
        this.addToCartBtnColor = DEFAULT_ADD_TO_BTN_COLOR
        return false
      }

      const orderCode = this.getOrderCode(item)
      const isChecked = this.$store.getters.isCheckedItem(product, orderCode)
      if (isChecked) {
        this.addToCartBtnColor = 'rgb(255, 154, 201)'
        this.isChecked = true
      } else {
        this.addToCartBtnColor = DEFAULT_ADD_TO_BTN_COLOR
        this.isChecked = false
      }
    },
    onSelectedOptionChanged (product, item) {
      this.updateChecked(product, item)
    },
    parsePrice (price) {
      if (price.value === 0) {
        return ' - '
      }
      return price.unit + price.value.toLocaleString()
    },
    addToCart (product, item) {
      if (item.option.length > 0 &&
          !this.selectedOption &&
          !this.isChecked) {
        Swal.fire({
          title: this.$t('newLP.noOptions'),
          icon: 'error'
        })
        return
      }
      const orderCode = this.getOrderCode(item)
      const payload = {
        ...item,
        orderCode,
        orderQuantity: item.MOQ || 1,
        orderDescription: '',
        product
      }

      this.$store.commit('toggleItem', payload)
      this.updateChecked(product, payload)
    }
  }
}
</script>
<style>
  #licenseproduct-detail .detail-row {
    white-space: nowrap;
  }

  #licenseproduct-detail .detail-row .detail-row-title {
    margin: 0px;
    padding-top: 10px;
    font-size: 14px;
  }

  #licenseproduct-detail .detail-row .detail-row-content{
    margin: 0px;
    padding-top: 0px;
    font-size: 20px;
  }

  #licenseproduct-detail .detail-row .card-info-country-tag{
    padding-left: 5px;
    padding-right: 5px;
    margin: 0px 5px 5px 0px;
    color: black;
    font-weight: bold;
    width: fit-content !important;
  }

  #licenseproduct-detail .card-info-action{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    max-width: 300px;
  }

  #licenseproduct-detail #add-to-cart-btn{
    margin: 0px;
    width: 100%;
    height: 40px;
    text-transform: inherit;
    background-color: #5a5a5a;
    color: white;
    font-weight: bold;
  }

  #licenseproduct-detail #add-to-cart-btn .selected{
    margin:0px;
    width: 100%;
    height: 45px;
    text-transform: inherit;
    background-color: #5a5a5a;
    color: white;
    font-weight: bold;
  }

  #licenseproduct-detail #add-to-cart-btn .btn-text-field{
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #selected-products-empty{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
    flex-direction: column;
  }

  #selected-products-empty #selected-products-empty-title{
    padding-top: 30px;
    margin: 0px;
    font-size: 24px;
    color: rgba(146, 146, 146, 0.9)
  }
</style>



// WEBPACK FOOTER //
// src/app/contents/LicenseProductDetail.vue